import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white py-5 px-4 text-center border-t border-gray-200" data-id="element-55">
      <div className="max-w-4xl mx-auto text-sm text-gray-500" data-id="element-56">
        <p className="font-bold text-gray-700 mb-1" data-id="element-57">
          🧠 KIT COMPLETO PRIMARIA LISTA
        </p>
        <p className="mb-2" data-id="element-58">© 2026 Kit Completo Primaria Lista™</p>
        <div className="flex justify-center gap-4" data-id="element-59">
          <span data-id="element-60">Términos</span>
          <span data-id="element-61">·</span>
          <span data-id="element-62">Privacidad</span>
          <span data-id="element-63">·</span>
          <span data-id="element-64">Soporte</span>
        </div>
      </div>
    </footer>;
}